// CAROUSEL WITH MULTIPLE ITEMS
( function ($) {
    $(document).ready(function () {
        childrenSlider();
    });
    function childrenSlider() {
        var wraps = $('.post_preview.layout_carousel');
        if (wraps.length > 0) {
            wraps.each(function () {
                var wrap = $(this);
                var slider = wrap.find('.children_section');
                if (slider.length > 0) {
                    slider.on("init", function () {
                        lazyLoadInstance.update();
                    });
                    slider.slick({
                        autoplay: false,
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        dots: true,
                        appendDots: wrap.find('.pager'),
                        variableWidth:false,
                        centerMode: false,
                        rtl: $('html').attr('dir') == 'rtl',
                        responsive: [
                            {
                                breakpoint: 1199,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                }
                            },
                            {
                                breakpoint: 500,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    adaptiveHeight: true
                                }
                            },
                        ]
                    });
                }
            })
        }
    }
}(jQuery) );